/** Generated by scripts/millistream-sectors-i18n-import.ts. Do not edit manually. */
export const millistreamSectorsTranslationsSv = {
    level1: {
        basic_materials: 'Råmaterial',
        'consumer_goods_&_services': 'Konsumentvaror & Tjänster',
        energy: 'Energi',
        financials: 'Finans',
        health_care: 'Hälsovård',
        industrials: 'Industri',
        real_estate: 'Fastighet',
        technology: 'Teknologi',
    },
    level2: {
        alternative_energy: 'Alternativa energikällor',
        automobiles: 'Fordonsindustri',
        banks: 'Bank',
        'biotechnology_&_pharmaceuticals': 'Bioteknik & Läkemedel',
        chemicals: 'Kemikalier & Industriella tillsatser',
        conglomerates: 'Konglomerat',
        'construction_&_materials': 'Bygg & Konstruktion',
        consumer_services: 'Konsumenttjänster',
        distribution: 'Distribution',
        'drilling_equipment_&_services': 'Borrutrustning & Tjänster',
        electrical_equipment: 'Elektronisk Utrustning',
        financial_services: 'Finansiella Tjänster',
        'food_&_beverage': 'Livsmedel',
        food_producers: 'Livsmedelsproducenter',
        hardware_manufacturer: 'Hårdvara',
        health_care_providers: 'Vård- och Omsorg',
        home_products: 'Hem & Bostad',
        'industrial_goods_&_services': 'Industriella Varor & Tjänster',
        investment: 'Investeringar',
        it_services: 'IT-Service',
        'media_&_entertainment': 'Media & Underhållning',
        'medical_equipment_&_services': 'Medicinsk Utrustning & Service',
        'metals_&_mining': 'Metall & Gruvdrift',
        multi: 'Multi',
        'non-renewable': 'Icke-förnyelsebar energiproduktion',
        'paper_&_forest_products': 'Papper & Skogsindustri',
        personal_goods: 'Personliga varor',
        'real_estate_investment_&_services': 'Fastighetsinvesteringar',
        'real_estate_management_&_development': 'Fastighet & Utveckling',
        renewable: 'Förnyelsebara energikällor',
        retailers: 'Återförsäljare',
        software: 'Mjukvara',
        telecommunications: 'Telekommunikation',
        'transport_&_logistics': 'Transport & Logistik',
    },
    level3: {
        agriculture: 'Lantbrukskemikalier',
        airlines: 'Flygbolag',
        asset_management: 'Kapitalförvaltning',
        'audio_&_video_streaming': 'Ljud & Video Streaming',
        auto_parts: 'Bildelar',
        'auto_services_&_dealers': 'Autoservice & Återförsäljare',
        automobiles: 'Biltillverkare',
        basic_metals: 'Basmetaller',
        'betting_&_casino': 'Betting & Kasino',
        biofuels: 'Biobränsle',
        biotechnology: 'Bioteknik',
        'brewer_&_beverage_provider': 'Bryggerier & Dryckestillverkare',
        cannabis: 'Cannabis',
        climate_solutions: 'Klimatlösningar',
        'clothes_&_accessories': 'Kläder & Accessoarer',
        commercial_real_estate: 'Kommersiella Fastigheter',
        community_properties: 'Samhällsfastigheter',
        'components_&_tools': 'Komponenter & Verktyg',
        conglomerates: 'Konglomerat',
        construction: 'Konstruktion',
        'consulting_&_installation': 'Konsult & Installationstjänster',
        consumer_chemicals: 'Konsumentkemikalier',
        consumer_electronics: 'Hemelektronik',
        cosmetics: 'Kosmetika',
        'credit_&_consumer_finance': 'Konsumentkredit',
        'cryptocurrency_&_platform_provider': 'Kryptovalutor & Plattformar',
        cybersecurity: 'Cybersäkerhet',
        data_storage: 'Datalagring',
        defense: 'Försvar',
        delivery_services: 'Leveranstjänster',
        digital_platforms: 'Digitala Plattformar',
        digital_services: 'Digitala Tjänster',
        distribution: 'Distribution',
        drilling_equipment: 'Borrutrustning',
        'e-commerce': 'E-Handel',
        education_services: 'Utbildning & Tjänster',
        electrical_components: 'Elektriska Komponenter',
        entertainment: 'Underhållning',
        facility_management: 'Fastighetsförvaltning',
        'farming,_ranching,_plantation_&_seafood': 'Jordbruk, odling och fiske',
        'financial_exchange_&_data_provider': 'Börs & Dataleverantörer',
        food_distributors: 'Livsmedelsdistributörer',
        food_products: 'Livsmedel',
        'forestry_&_forest_products': 'Skog & Massaindustri',
        game_producers: 'Spelutvecklare',
        gas: 'Gas',
        'geological_products_&_services': 'Geologiska Produkter & Tjänster',
        hardware_equipment: 'Hårdvaruutrustning',
        health_care_facilities: 'Sjukvårdsanläggningar',
        health_care_services: 'Hälsovårdstjänster',
        home_construction: 'Byggvaror',
        'hotel_&_resort': 'Hotell & Resort',
        household_appliances: 'Vitvaror',
        household_items: 'Hushållsprodukter',
        hydrogen: 'Vätgas',
        industrial_appliances: 'Industriella vitvaror',
        industrial_chemicals: 'Industrikemikalier',
        insurance: 'Försäkring',
        investment_companies: 'Investmentbolag',
        it_consulting: 'IT-Konsulter',
        materials: 'Material',
        'media_&_publishing': 'Media & Publikation',
        medical_equipment: 'Medicinsk utrustning',
        medical_services: 'Medicinska tjänster',
        mostly_renewable: 'Främst förnyelsebar',
        office: 'Kontor',
        oil: 'Olja',
        other_consumer_services: 'Övriga konsumenttjänster',
        paper_products: 'Pappersprodukter',
        'payment_solutions_&_transactions': 'Betalningslösningar & Transaktioner',
        personal_care: 'Personlig Hygien',
        pharmaceuticals: 'Läkemedel',
        'power_outlets_&_charging_stations': 'Eluttag & Laddningstationer',
        precious_metals: 'Ädelmetaller',
        'process_&_automation': 'Process & Automation',
        public_transports: 'Kollektivtransporter',
        rare_earth_metals: 'Sällsynta Jordartsmetaller',
        real_estate_development: 'Fastighetsutveckling',
        residental: 'Bostäder',
        'saas-provider': 'SaaS-Leverantörer',
        'savings_&_investment': 'Sparande & Investering',
        security_services: 'Säkerhetstjänster',
        semiconductors: 'Halvledare',
        shipping: 'Sjöfart',
        solar: 'Solenergi',
        spac: 'SPAC',
        space_industry: 'Rymdindustri',
        staffing_services: 'Bemanning',
        stores: 'Butiker',
        supplements: 'Kosttillskott',
        'telecommunications_-_equipment': 'Telekomutrustning',
        'telecommunications_-_service_provider': 'Nätleverantörer',
        tobacco_provider: 'Tobakstillverkare',
        traditional_banking: 'Traditionell Bankverksamhet',
        'travel_&_leisure': 'Resor & Nöjen',
        'trucks_&_heavy_vehicles': 'Lastbilar & Tunga Fordon',
        'warehouse_&_logistics': 'Lager & Logistik',
        'waste_&_recycling': 'Avfall & Återvinning',
        water: 'Vattenenergi',
        wind: 'Vindenergi',
    },
}
